import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, ComponentFactoryResolver, Inject, Input } from '@angular/core';
import { StartupService } from '@core';
import { CustomMessages } from '@shared/components/custom-messages/custom-messages';
import { AgRendererComponent, ICellRendererAngularComp } from 'ag-grid-angular';

import { AuditorBenchAuditDetailScopeDetailDTO } from 'app/model/auditor-bench-audit-detail-scope-detail-dto';
import { AuditDetailsService } from 'app/service/audit-details.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-button-renderer',
  template: `
    <div style="text-align: center; display: flex; align-items: center;">
      <button
        mat-icon-button
        [disabled]="readOnly"
        matTooltip="Delete"
        id="deleteRemark"
        style="top:-7px"
        (click)="openDialog()"
      >
        <svg
          version="1.1"
          width="20"
          height="20"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 24 24"
          style="enable-background:new 0 0 24 24;"
          xml:space="preserve"
        >
          <circle style="fill:#DA2128;" cx="12" cy="12" r="12" />
          <path style="fill:none;" d="M4,4h16v16H4V4z" />
          <path
            style="fill:#FFFFFF;"
            class="st2"
            d="M14.6,10v6.6H9.4V10H14.6 M13.7,6h-3.3L9.7,6.7H7.4V8h9.3V6.7h-2.3L13.7,6z M16,8.7H8v8
	                        C8,17.4,8.6,18,9.4,18h5.3c0.7,0,1.3-0.6,1.3-1.3V8.7z"
          />
        </svg>
      </button>
    </div>
  `,
})
export class ButtonRendererComponent implements ICellRendererAngularComp, AgRendererComponent {
  params: any;
  label: string;
  parsedJson: any;

  @Input() scopeDetailDTO: any | undefined;
  auditorBenchAuditDetailScopeDetailDTO: AuditorBenchAuditDetailScopeDetailDTO = new AuditorBenchAuditDetailScopeDetailDTO();
  userId: any;
  message: string = '';
  readOnly: boolean = false;

  constructor(
    public customMessage: CustomMessages,
    private startupService: StartupService,
    private auditDetailsService: AuditDetailsService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.readOnly = this.params.node.data.isReadOnly;
    // alert(this.readOnly)
  }

  agInit(params): void {
    this.params = params;
    // alert(params);
    // alert(params.value);
    this.label = this.params.label || null;
    var char = JSON.parse(localStorage.getItem('clientList'));
    this.userId = char[0].userDetails.userId;
  }

  refresh(params?: any): boolean {
    return true;
  }

  onClick($event) {
    //  alert("inside on click");
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
        // ...something
      };
      this.params.onClick(this.params);
    }
  }
  openDialog() {
    const dialogRef = this.dialog.open(DialogBoxComponent, {
      width: '500px',
      data: { component: this },
    });

    dialogRef.afterClosed().subscribe(result => {});
  }

  onDeleteClick() {
    let selectedNode = this.params.node;
    let selectedData = selectedNode.data;
    // this.params.api.updateRowData({ remove: [selectedData] });
    this.auditorBenchAuditDetailScopeDetailDTO.gvCreatedBy = this.userId;
    this.auditorBenchAuditDetailScopeDetailDTO.pId = this.params.node.data.id;
    this.auditorBenchAuditDetailScopeDetailDTO.scopeId = this.params.node.data.scope_Id;
    this.auditorBenchAuditDetailScopeDetailDTO.isGvEnabled = 1;
    this.auditDetailsService.deleteGvRemarks(this.auditorBenchAuditDetailScopeDetailDTO).subscribe(
      data => {
        // this.customMessage.showSuccessMessage("Deleted Successfully");
        this.parsedJson = JSON.parse(JSON.stringify(data));
        // alert(JSON.stringify(this.parsedJson));
        this.message = this.parsedJson.message;
        if (this.message == 'Deleted SuccessFully') {
          this.params.api.updateRowData({ remove: [selectedData] });
          this.customMessage.showSuccessMessage('cams.label.common.deletedSuccessfully');
        }
        if (this.message == 'User who has posted, can delete remarks') {
          this.customMessage.showSuccessMessage('cams.label.common.userHasPostedCannotDelete');
        }
        if (this.message == 'Status is Closed cannot delete') {
          this.customMessage.showSuccessMessage('cams.label.common.statusClosed');
        }
      },
      error => {
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      }
    );
  }
}

@Component({
  selector: 'app-dialog-box',
  template: `
    <div class="custom-dialog">
      <button mat-button [mat-dialog-close]="true" class="close-btn">
        <mat-icon>close</mat-icon>
      </button>
      <h1 mat-dialog-title>CONFIRM</h1>
      <div mat-dialog-content>
        <p>Are you sure to delete this comment?</p>
      </div>
      <div mat-dialog-actions fxLayoutAlign="center center">
        <button mat-raised-button (click)="onNoClick()">No</button>
        <button mat-raised-button color="primary" (click)="onYesClick()">Yes</button>
      </div>
    </div>
  `,
})
export class DialogBoxComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
  onYesClick(): void {
    this.data.component.onDeleteClick();
    this.dialogRef.close();
  }
}
